import React from 'react';
import { ICrmContextState } from './ICrmContextState';

export const CrmContext = React.createContext<ICrmContextState>({} as ICrmContextState);
